import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Popper } from "@mui/material";

// Driven imperatively via ref: showing on hover must never re-render the owner chart —
// a nivo-layer re-render remounts the hovered <rect> and swallows its mouseleave.
const HyroHoverTooltip = forwardRef(({ renderContent, placement = "top", modifiers }, ref) => {
  const [tooltip, setTooltip] = useState(null);
  const open = Boolean(tooltip);

  useImperativeHandle(ref, () => ({
    show: (data, rect, options = {}) => setTooltip({ data, rect, ...options }),
    hide: () => setTooltip(null)
  }));

  useEffect(() => {
    if (!open) return undefined;
    const hide = () => setTooltip(null);
    window.addEventListener("scroll", hide, { capture: true, passive: true });
    return () => window.removeEventListener("scroll", hide, { capture: true });
  }, [open]);

  if (!tooltip) return null;

  return (
    <Popper
      open
      data-testid="hyro-hover-tooltip"
      placement={placement}
      anchorEl={{ getBoundingClientRect: () => tooltip.rect }}
      modifiers={typeof modifiers === "function" ? modifiers(tooltip) : modifiers}
      sx={{ pointerEvents: "none", zIndex: "tooltip" }}
    >
      {renderContent(tooltip.data)}
    </Popper>
  );
});

HyroHoverTooltip.displayName = "HyroHoverTooltip";

export default HyroHoverTooltip;
